if (document.documentElement.lang.toLowerCase().split('-')[0] === 'de') {
(() => {
  'use strict';

  const shell = document.querySelector('.ae-product-final[data-product-handle]');
  if (!shell) return;

  const isTr = document.documentElement.lang.toLowerCase().startsWith('tr');
  const isDe = document.documentElement.lang.toLowerCase().startsWith('de');
  const currentHandle = shell.dataset.productHandle || '';
  const reviewCount = Number(shell.dataset.reviewCount || 0);
  const reviewRating = Number(shell.dataset.reviewRating || 0);

  // ASTERIA ELITE — PRODUCT STORY 10-LINE COLLAPSE V1
  function initStoryCollapse() {
    const copy = shell.querySelector('[data-ae-story-copy]');
    const toggle = shell.querySelector('[data-ae-story-toggle]');
    if (!copy || !toggle) return;

    const label = toggle.querySelector('[data-ae-story-toggle-label]');

    const sync = () => {
      if (copy.classList.contains('is-expanded')) return;
      toggle.hidden = !(copy.scrollHeight > copy.clientHeight + 2);
    };

    toggle.addEventListener('click', () => {
      const expanded = copy.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) {
        label.textContent = expanded
          ? (toggle.dataset.showLess || (isTr ? 'Daha Az Göster' : isDe ? 'Weniger anzeigen' : 'Show Less'))
          : (toggle.dataset.readMore || (isTr ? 'Devamını Oku' : isDe ? 'Weiterlesen' : 'Read More'));
      }
    });

    requestAnimationFrame(sync);
    window.addEventListener('load', sync, { once: true });
    window.addEventListener('resize', sync);
  }

  initStoryCollapse();

  function initReviews() {
    const section = document.getElementById('shopify-section-reviews');
    if (!section) return false;

    if (reviewCount < 1) {
      section.classList.add('ae-reviews-empty');
      return true;
    }

    if (!section.querySelector('.ae-reviews-heading')) {
      const head = document.createElement('div');
      head.className = 'ae-reviews-heading';
      head.innerHTML = '<h2>' + (isTr ? 'Müşteri Yorumları' : isDe ? 'Kundenbewertungen' : 'Customer Reviews') + '</h2><span>' +
        (reviewRating ? '★ ' + reviewRating.toFixed(1) + ' · ' : '') +
        reviewCount + (isTr ? ' yorum</span>' : isDe ? ' Bewertungen</span>' : ' reviews</span>');
      section.prepend(head);
    }

    const reviews = Array.from(section.querySelectorAll('.jdgm-rev'));
    if (!reviews.length) return false;

    reviews.forEach((review, index) => {
      review.classList.toggle('ae-review-extra', index >= 2);
    });

    const oldToggle = section.querySelector('.ae-reviews-toggle');
    if (reviews.length > 2 && !oldToggle) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ae-reviews-toggle';
      button.textContent = (isTr ? 'Tüm Yorumları Gör (' : isDe ? 'Alle Bewertungen anzeigen (' : 'View All Reviews (') + reviewCount + ')';
      button.addEventListener('click', () => {
        const expanded = section.classList.toggle('ae-reviews-expanded');
        button.textContent = expanded ? (isTr ? 'Yorumları Daralt' : isDe ? 'Weniger Bewertungen anzeigen' : 'Show Fewer Reviews') : (isTr ? 'Tüm Yorumları Gör (' : isDe ? 'Alle Bewertungen anzeigen (' : 'View All Reviews (') + reviewCount + ')';
      });
      section.appendChild(button);
    }
    return true;
  }

  if (!initReviews()) {
    const reviewObserver = new MutationObserver(() => {
      if (initReviews()) reviewObserver.disconnect();
    });
    reviewObserver.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => reviewObserver.disconnect(), 12000);
  }

  const storageKey = 'asteria_recent_products_v1';
  let recent = [];
  try {
    recent = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (!Array.isArray(recent)) recent = [];
  } catch (_) {
    recent = [];
  }

  const previous = recent.filter(h => h && h !== currentHandle).slice(0, 4);
  const updated = [currentHandle, ...recent.filter(h => h && h !== currentHandle)].filter(Boolean).slice(0, 10);
  try { localStorage.setItem(storageKey, JSON.stringify(updated)); } catch (_) {}

  function money(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY';
    const locale = document.documentElement.lang || 'tr-TR';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(cents || 0) / 100);
    } catch (_) {
      return (Number(cents || 0) / 100).toFixed(2) + ' ' + currency;
    }
  }

  async function renderRecent() {
    if (!previous.length) return;
    const target = document.querySelector('#shopify-section-related-products .related-products');
    if (!target || target.querySelector('.ae-recently-viewed')) return;

    const products = (await Promise.all(previous.map(async handle => {
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
        if (!res.ok) return null;
        return await res.json();
      } catch (_) {
        return null;
      }
    }))).filter(Boolean);

    if (!products.length) return;

    const wrap = document.createElement('div');
    wrap.className = 'ae-recently-viewed';
    const heading = document.createElement('h3');
    heading.textContent = isTr ? 'İlgini Çekebilecekler' : isDe ? 'Das könnte Ihnen auch gefallen' : 'You May Also Like';
    wrap.appendChild(heading);

    const grid = document.createElement('div');
    grid.className = 'ae-recently-viewed__grid';

    products.slice(0, 4).forEach(product => {
      const card = document.createElement('a');
      card.className = 'ae-recent-card';
      card.href = (window.Shopify?.routes?.root || '/') + 'products/' + product.handle;
      const image = product.featured_image || (product.images && product.images[0]) || '';
      card.innerHTML =
        '<span class="ae-recent-card__media">' +
          (image ? '<img src="' + image + '" alt="" loading="lazy">' : '') +
        '</span>' +
        '<span class="ae-recent-card__body"><strong></strong><em>' + money(product.price) + '</em></span>';
      card.querySelector('strong').textContent = product.title || '';
      grid.appendChild(card);
    });

    wrap.appendChild(grid);
    target.prepend(wrap);
  }

  renderRecent();
  const relatedObserver = new MutationObserver(renderRecent);
  const relatedSection = document.getElementById('shopify-section-related-products');
  if (relatedSection) {
    relatedObserver.observe(relatedSection, { childList: true, subtree: true });
    setTimeout(() => relatedObserver.disconnect(), 12000);
  }
})();


} else {
(() => {
  'use strict';

  const shell = document.querySelector('.ae-product-final[data-product-handle]');
  if (!shell) return;

  const isTr = document.documentElement.lang.toLowerCase().startsWith('tr');
  const currentHandle = shell.dataset.productHandle || '';
  const reviewCount = Number(shell.dataset.reviewCount || 0);
  const reviewRating = Number(shell.dataset.reviewRating || 0);

  // ASTERIA ELITE — PRODUCT STORY 10-LINE COLLAPSE V1
  function initStoryCollapse() {
    const copy = shell.querySelector('[data-ae-story-copy]');
    const toggle = shell.querySelector('[data-ae-story-toggle]');
    if (!copy || !toggle) return;

    const label = toggle.querySelector('[data-ae-story-toggle-label]');
    const isTr = (document.documentElement.lang || '').toLowerCase().startsWith('tr');

    const sync = () => {
      if (copy.classList.contains('is-expanded')) return;
      toggle.hidden = !(copy.scrollHeight > copy.clientHeight + 2);
    };

    toggle.addEventListener('click', () => {
      const expanded = copy.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) {
        label.textContent = expanded
          ? (isTr ? 'Daha Az Göster' : 'Show Less')
          : (isTr ? 'Devamını Oku' : 'Read More');
      }
    });

    requestAnimationFrame(sync);
    window.addEventListener('load', sync, { once: true });
    window.addEventListener('resize', sync);
  }

  initStoryCollapse();

  function initReviews() {
    const section = document.getElementById('shopify-section-reviews');
    if (!section) return false;

    if (reviewCount < 1) {
      section.classList.add('ae-reviews-empty');
      return true;
    }

    if (!section.querySelector('.ae-reviews-heading')) {
      const head = document.createElement('div');
      head.className = 'ae-reviews-heading';
      head.innerHTML = '<h2>' + (isTr ? 'Müşteri Yorumları' : 'Customer Reviews') + '</h2><span>' +
        (reviewRating ? '★ ' + reviewRating.toFixed(1) + ' · ' : '') +
        reviewCount + (isTr ? ' yorum</span>' : ' reviews</span>');
      section.prepend(head);
    }

    const reviews = Array.from(section.querySelectorAll('.jdgm-rev'));
    if (!reviews.length) return false;

    reviews.forEach((review, index) => {
      review.classList.toggle('ae-review-extra', index >= 2);
    });

    const oldToggle = section.querySelector('.ae-reviews-toggle');
    if (reviews.length > 2 && !oldToggle) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ae-reviews-toggle';
      button.textContent = (isTr ? 'Tüm Yorumları Gör (' : 'View All Reviews (') + reviewCount + ')';
      button.addEventListener('click', () => {
        const expanded = section.classList.toggle('ae-reviews-expanded');
        button.textContent = expanded ? (isTr ? 'Yorumları Daralt' : 'Show Fewer Reviews') : (isTr ? 'Tüm Yorumları Gör (' : 'View All Reviews (') + reviewCount + ')';
      });
      section.appendChild(button);
    }
    return true;
  }

  if (!initReviews()) {
    const reviewObserver = new MutationObserver(() => {
      if (initReviews()) reviewObserver.disconnect();
    });
    reviewObserver.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => reviewObserver.disconnect(), 12000);
  }

  const storageKey = 'asteria_recent_products_v1';
  let recent = [];
  try {
    recent = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (!Array.isArray(recent)) recent = [];
  } catch (_) {
    recent = [];
  }

  const previous = recent.filter(h => h && h !== currentHandle).slice(0, 4);
  const updated = [currentHandle, ...recent.filter(h => h && h !== currentHandle)].filter(Boolean).slice(0, 10);
  try { localStorage.setItem(storageKey, JSON.stringify(updated)); } catch (_) {}

  function money(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY';
    const locale = document.documentElement.lang || 'tr-TR';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(cents || 0) / 100);
    } catch (_) {
      return (Number(cents || 0) / 100).toFixed(2) + ' ' + currency;
    }
  }

  async function renderRecent() {
    if (!previous.length) return;
    const target = document.querySelector('#shopify-section-related-products .related-products');
    if (!target || target.querySelector('.ae-recently-viewed')) return;

    const products = (await Promise.all(previous.map(async handle => {
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
        if (!res.ok) return null;
        return await res.json();
      } catch (_) {
        return null;
      }
    }))).filter(Boolean);

    if (!products.length) return;

    const wrap = document.createElement('div');
    wrap.className = 'ae-recently-viewed';
    const heading = document.createElement('h3');
    heading.textContent = isTr ? 'İlgini Çekebilecekler' : 'You May Also Like';
    wrap.appendChild(heading);

    const grid = document.createElement('div');
    grid.className = 'ae-recently-viewed__grid';

    products.slice(0, 4).forEach(product => {
      const card = document.createElement('a');
      card.className = 'ae-recent-card';
      card.href = (window.Shopify?.routes?.root || '/') + 'products/' + product.handle;
      const image = product.featured_image || (product.images && product.images[0]) || '';
      card.innerHTML =
        '<span class="ae-recent-card__media">' +
          (image ? '<img src="' + image + '" alt="" loading="lazy">' : '') +
        '</span>' +
        '<span class="ae-recent-card__body"><strong></strong><em>' + money(product.price) + '</em></span>';
      card.querySelector('strong').textContent = product.title || '';
      grid.appendChild(card);
    });

    wrap.appendChild(grid);
    target.prepend(wrap);
  }

  renderRecent();
  const relatedObserver = new MutationObserver(renderRecent);
  const relatedSection = document.getElementById('shopify-section-related-products');
  if (relatedSection) {
    relatedObserver.observe(relatedSection, { childList: true, subtree: true });
    setTimeout(() => relatedObserver.disconnect(), 12000);
  }
})();


}
